import React from 'react';
import { NextPage, GetServerSideProps } from 'next';
import styled from 'styled-components';

import { Link as StyledLink } from '@makeship/core';
import Container from '../components/Container';
import Head from '../components/Head';
import { H1, H4Styles, H5, H6, P2 } from '../components/Typography';
import { getPageByHandle } from '../api/shop';
import { transformHtml } from '../utils/htmr';
import { getPropsForPageLoad } from '../utils/pageLoad';

const FAQContainer = styled(Container)`
  padding: 48px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding: 16px;
  }
`;

const Heading = styled(H1)`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    ${H4Styles}
  }
`;

const QuestionH6 = styled(H6)`
  margin-top: 32px;
`;

type FAQPageType = {
  body: string;
};

const FAQPage: NextPage<FAQPageType> = ({ body }: FAQPageType) => (
  <>
    <Head title="FAQ" url="/faq" />
    <FAQContainer>
      {transformHtml(body, {
        h1: Heading,
        h5: H5,
        h6: QuestionH6,
        p: P2,
        a: StyledLink.Primary,
      })}
    </FAQContainer>
  </>
);

export const getServerSideProps: GetServerSideProps<FAQPageType> = async (ctx) => {
  const page = await getPageByHandle('frequently-asked-questions');
  const propsForPageLoad = await getPropsForPageLoad(ctx);

  return {
    props: {
      body: page?.body,
      ...propsForPageLoad,
    },
  };
};

export default FAQPage;
